import { View, Text } from '@react-pdf/renderer';
import React from 'react';
import { styles } from './styles';

const Items = () => {
  return (
    <View style={{ marginTop: '20px' }}>
      <View style={styles.item}>
        <Text style={{ marginHorizontal: 8 }}> • </Text>
        <Text style={{ flex: 1 }}>
          El acceso a la información se hará efectivo a través de la persona que
          la Empresa autoriza como "Administrador", siendo esta la única
          responsable por dicha persona.
        </Text>
      </View>
      <View style={styles.item}>
        <Text style={{ marginHorizontal: 8 }}> • </Text>{' '}
        <Text style={{ flex: 1 }}>
          El "Administrador" accederá a toda la información publicada en el
          sitio, y tendrá bajo su responsabilidad la asignación de permisos y
          roles a los demás "Usuarios".
        </Text>
      </View>
      <View style={styles.item}>
        <Text style={{ marginHorizontal: 8 }}> • </Text>
        <Text style={{ flex: 1 }}>
          La Empresa se compromete a extremar las medidas que resulten
          necesarias a fin de resguardar la confidencialidad y confiabilidad de
          la totalidad de los usuarios.
        </Text>
      </View>
      <View style={styles.item}>
        <Text style={{ marginHorizontal: 8 }}> • </Text>
        <Text style={{ flex: 1 }}>
          Esta solicitud se considerará aceptada en todos sus términos por la
          Bolsa, cuando habilite a la Empresa el acceso al servicio.
        </Text>
      </View>
      <View style={styles.item}>
        <Text style={{ marginHorizontal: 8 }}> • </Text>
        <Text style={{ flex: 1 }}>
          La información comunicada a la Bolsa será válida hasta tanto no se
          notifique en forma fehaciente su cambio. La empresa se compromete a
          comunicar cualquier modificación que se produzca en la información
          suministrada y declara conocer que la baja de la persona autorizada
          sólo tendrá efectos ante la Bolsa a partir del momento que se
          notifique fehacientemente dicha circunstancia.
        </Text>
      </View>
      <View style={styles.item}>
        <Text style={{ marginHorizontal: 8 }}> • </Text>
        <Text style={{ flex: 1 }}>
          El/Los abajo firmante/s declara/n que se ha/n sido informado/s de lo
          dispuesto por el Artículo 6 de la ley 25.326, dando expreso
          consentimiento a la Bolsa para el tratamiento y/o cesión de sus datos
          personales.
        </Text>
      </View>
    </View>
  );
};

export default Items;
